module.exports = __webpack_public_path__ + "media/images/standart_plus-616e6dfa29dac7af5efd50b23e2b81fe.svg";